"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _CookieConsentBanner_instances, _CookieConsentBanner_createBanner, _CookieConsentBanner_setupCloseButtonEvent, _CookieConsentBanner_isMounted, _CookieConsentBanner_isShow, _CookieConsentBanner_setVisibilityOnOverlap, _CookieConsentBanner_temporarilyInvisible, _CookieConsentBanner_revertInvisible;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieConsentBanner = void 0;
exports.saveCookie = saveCookie;
const js_cookie_js_1 = __importDefault(require("./js-cookie/js-cookie.js"));
const BoundingRectObserver_1 = require("./utils/BoundingRectObserver");
class CookieConsentBanner {
    constructor() {
        _CookieConsentBanner_instances.add(this);
        this.isCreated = false;
        // バナーのhtmlテンプレート
        // ルート要素は一つにすること
        this.template = `<div class="c-cookieConsentBanner">
    <div class="c-cookieConsentBanner__inner">
        <p class="c-cookieConsentBanner__text">このウェブサイトでは、サイトの利便性向上やお客様に合わせたコンテンツや広告向け情報の収集などのため、Cookieを利用します。なお、ご利用ブラウザの設定でCookieを無効にすることも可能ですが、サイトの機能を十分にご利用いただくことができない可能性があります。[<a href="https://www.itoen.co.jp/company/policy/privacy_policy/" target="_blank">プライバシーポリシーについて</a>]</p>
        <button class="c-cookieConsentBanner__button js-cookie-consent-banner-close">閉じる</button>
    </div>
</div>`;
    }
    /**
     * クッキーが存在しているかを確認して、なければ（初回 or 閉じるを押していない）バナーを生成＆表示
     */
    render() {
        const savedValue = js_cookie_js_1.default.get(CookieConsentBanner.COOKIE_KEY);
        // console.log(
        //   "CookieBanner render",
        //   "value: ",
        //   savedValue,
        //   "mounted: ",
        //   this.#isMounted(),
        //   "show: ",
        //   this.#isShow()
        // )
        if (savedValue !== "1" && !this.isCreated) {
            __classPrivateFieldGet(this, _CookieConsentBanner_instances, "m", _CookieConsentBanner_createBanner).call(this);
        }
        // トップページのKVに重なるのを回避するため表示領域を監視する
        const topKv = getTopKv();
        if (topKv) {
            this.topKv = topKv;
            // KVとの重なりが検出できるまでは非表示にしておく
            this.hide();
            // KV画像の読み込みを待ってから処理する
            // KVのサイズが読み込み後に変わるため、完了前はサイズが取得できずCookieバナーが一瞬表示されてしまうため
            if (document.readyState == "complete") {
                // この時点で完了済み
                this.hideCookieBannerIfOverlappingKV();
            }
            else {
                // 読み込みを待つ
                window.addEventListener("load", () => {
                    this.hideCookieBannerIfOverlappingKV();
                });
            }
        }
        else {
            this.show();
        }
    }
    /**
     * KVがある場合は重なっているときは、Cookie同意バナーを非表示にする
     */
    hideCookieBannerIfOverlappingKV() {
        // KVとバナーそれぞれに、BoundingRectの変更を検知する処理を設定
        // 表示領域が変更されたら重なりを検知する
        if (this.topKv) {
            // KV用
            this.topKvBoundingRectObserver = new BoundingRectObserver_1.BoundingRectObserver(this.topKv);
            this.topKvBoundingRectObserver.addEventListener("change", () => {
                __classPrivateFieldGet(this, _CookieConsentBanner_instances, "m", _CookieConsentBanner_setVisibilityOnOverlap).call(this);
            });
            this.topKvBoundingRectObserver.start();
        }
        // 同意バナー用
        if (this.el) {
            this.boundingRectObserver = new BoundingRectObserver_1.BoundingRectObserver(this.el);
            this.boundingRectObserver.addEventListener("change", () => {
                __classPrivateFieldGet(this, _CookieConsentBanner_instances, "m", _CookieConsentBanner_setVisibilityOnOverlap).call(this);
            });
            this.boundingRectObserver.start();
        }
    }
    show() {
        if (this.el) {
            this.el.ariaHidden = "false";
        }
    }
    hide() {
        if (this.el) {
            this.el.ariaHidden = "true";
        }
    }
    destroy() {
        var _a, _b, _c;
        // トップページKV用のイベントを削除
        (_a = this.topKvBoundingRectObserver) === null || _a === void 0 ? void 0 : _a.destroy();
        this.topKvBoundingRectObserver = null;
        (_b = this.boundingRectObserver) === null || _b === void 0 ? void 0 : _b.destroy();
        this.boundingRectObserver = null;
        this.isCreated = false;
        // 要素を削除
        (_c = this.el) === null || _c === void 0 ? void 0 : _c.remove();
        this.el = undefined;
    }
}
exports.CookieConsentBanner = CookieConsentBanner;
_CookieConsentBanner_instances = new WeakSet(), _CookieConsentBanner_createBanner = function _CookieConsentBanner_createBanner() {
    // 文字列からDOMを制定
    const parser = new DOMParser();
    const doc = parser.parseFromString(this.template.trim(), "text/html");
    const el = doc.body.firstElementChild;
    if (el) {
        document.body.insertAdjacentElement("beforeend", el);
        // 表示を制御するため参照を保持しておく
        this.el = el;
        this.isCreated = true;
        // 閉じるボタンにイベントを設定する
        __classPrivateFieldGet(this, _CookieConsentBanner_instances, "m", _CookieConsentBanner_setupCloseButtonEvent).call(this);
    }
}, _CookieConsentBanner_setupCloseButtonEvent = function _CookieConsentBanner_setupCloseButtonEvent() {
    if (this.el) {
        const buttons = document.querySelectorAll(".js-cookie-consent-banner-close");
        buttons.forEach((button) => {
            button.addEventListener("click", () => {
                saveCookie();
                this.destroy();
            });
        });
    }
}, _CookieConsentBanner_isMounted = function _CookieConsentBanner_isMounted() {
    var _a;
    return !!((_a = this.el) === null || _a === void 0 ? void 0 : _a.parentNode);
}, _CookieConsentBanner_isShow = function _CookieConsentBanner_isShow() {
    if (!this.el || !__classPrivateFieldGet(this, _CookieConsentBanner_instances, "m", _CookieConsentBanner_isMounted).call(this)) {
        return false;
    }
    return this.el.ariaHidden === "false";
}, _CookieConsentBanner_setVisibilityOnOverlap = function _CookieConsentBanner_setVisibilityOnOverlap() {
    if (this.el && this.topKv) {
        if (isOverlapping(this.el, this.topKv)) {
            __classPrivateFieldGet(this, _CookieConsentBanner_instances, "m", _CookieConsentBanner_temporarilyInvisible).call(this);
        }
        else {
            // KVがあるときは非表示になっているので、表示しておく
            if (!__classPrivateFieldGet(this, _CookieConsentBanner_instances, "m", _CookieConsentBanner_isShow).call(this)) {
                this.show();
            }
            __classPrivateFieldGet(this, _CookieConsentBanner_instances, "m", _CookieConsentBanner_revertInvisible).call(this);
        }
    }
}, _CookieConsentBanner_temporarilyInvisible = function _CookieConsentBanner_temporarilyInvisible() {
    if (this.el && !this.el.classList.contains("is-invisible")) {
        this.el.classList.add("is-invisible");
    }
}, _CookieConsentBanner_revertInvisible = function _CookieConsentBanner_revertInvisible() {
    if (this.el && this.el.classList.contains("is-invisible")) {
        this.el.classList.remove("is-invisible");
    }
};
CookieConsentBanner.COOKIE_KEY = "itoencojp_cookie_usage_consent";
function saveCookie() {
    js_cookie_js_1.default.set(CookieConsentBanner.COOKIE_KEY, "1", {
        path: "/",
        expires: 365 * 100 // 実質無期限にするため100年を指定。ただし、ブラウザによって上限がある。だいたい1年くらい？
    });
}
/**
 * 衝突判定
 * @param el1
 * @param el2
 */
function isOverlapping(el1, el2) {
    const rect1 = el1.getBoundingClientRect();
    const rect2 = el2.getBoundingClientRect();
    // 一部でも重なっていればtrueと判定する
    return !(rect1.right < rect2.left ||
        rect1.left > rect2.right ||
        rect1.bottom < rect2.top ||
        rect1.top > rect2.bottom);
}
/**
 * トップページのKVを取得
 */
function getTopKv() {
    return document.querySelector("#top_hero");
}
